import { render } from "./MainBannerSmallScreen.vue?vue&type=template&id=7840bd9e"
import script from "./MainBannerSmallScreen.vue?vue&type=script&lang=js"
export * from "./MainBannerSmallScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__